import { HttpMethod, RequestOptions, useUserOrKioskRequest } from "../../common/lib/fetch";

const useReceivingAcceptTareWeight = (stagedPurchaseOrderId: string, options: RequestOptions) =>
  useUserOrKioskRequest<void>({
    method: HttpMethod.POST,
    path: `/api/stagedPurchaseOrders/${stagedPurchaseOrderId}/tareWeight`
  }, options);

export default useReceivingAcceptTareWeight;
